import moment from "moment";

export const money = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});
export const moneyShort = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 0,
});
export const formatMoney = (value) =>
  value === undefined || value === null || value === "" || isNaN(value)
    ? "—"
    : money.format(Number(value));
export const formatDate = (value) =>
  value ? moment(value).format("DD MMM YYYY") : "—";

export const emptyReportFilter = {
  regulator: "",
  investment_type: "",
  premium_charged_start: "",
  premium_charged_end: "",
  purchased_start: "",
  purchased_end: "",
  maturity_start: "",
  maturity_end: "",
};

// Premium earned/unearned for one approved policy, for the "premium charged"
// period in the filter (or up to today). Dates come in as YYYY-MM-DD.
export function premiumRow(item, filterData) {
  const id = item._id;
  const { policy_number, description, institution, policy_type, tenure, daily_premium } =
    item;
  const purchase_date = moment(item.purchase_date).format("YYYY-MM-DD");
  const maturity_date = moment(item.maturity_date).format("YYYY-MM-DD");
  let cost = item.cost;

  let status = moment(maturity_date) > moment() ? "Active" : "Exhausted";
  const date2 = moment();
  const date1 = moment(purchase_date);
  let days_earned = date2.diff(date1, "days");
  let premium_charged = days_earned * daily_premium;
  let days_unearned = tenure - days_earned;
  let cumulative_premium = days_earned * daily_premium;
  let premium_uncharged = days_unearned * daily_premium;

  if (status === "Exhausted") {
    days_earned = moment(maturity_date).diff(purchase_date, "days");
    days_unearned = 0;
    cumulative_premium = days_earned * daily_premium;
    premium_uncharged = days_unearned * daily_premium;
    premium_charged = 0;
  }

  if (filterData.premium_charged_start && filterData.premium_charged_end) {
    if (
      moment(purchase_date) < moment(filterData.premium_charged_start) &&
      moment(maturity_date) < moment(filterData.premium_charged_start) &&
      status === "Exhausted"
    ) {
      cumulative_premium = cost;
      premium_uncharged = 0;
    }
    if (moment(filterData.premium_charged_end) < moment(purchase_date)) {
      cost = 0;
      premium_uncharged = 0;
      cumulative_premium = 0;
      days_earned = 0;
      days_unearned = 0;
      premium_charged = 0;
      status = "investment was not available then";
    }

    // the period ends after the policy matured
    if (moment(filterData.premium_charged_end) > moment(maturity_date)) {
      days_earned = moment(maturity_date).diff(moment(purchase_date), "days");
      days_unearned = 0;
      cumulative_premium = days_earned * premium_charged;
      premium_uncharged = Math.abs(cost - cumulative_premium);
    }
    // the policy runs across the whole period
    if (
      moment(purchase_date) <= moment(filterData.premium_charged_start) &&
      moment(maturity_date) > moment(filterData.premium_charged_end)
    ) {
      const diff = moment(filterData.premium_charged_end).diff(
        moment(filterData.premium_charged_start),
        "days"
      );
      const cummDateDiff = moment(filterData.premium_charged_end).diff(
        moment(purchase_date),
        "days"
      );
      days_earned = cummDateDiff;
      days_unearned = tenure - cummDateDiff;
      premium_uncharged = (tenure - cummDateDiff) * daily_premium;
      cumulative_premium = cummDateDiff * daily_premium;
      premium_charged = (diff + 1) * daily_premium;
    }
    // bought before the period, matured inside it
    if (
      moment(purchase_date) < moment(filterData.premium_charged_start) &&
      moment(maturity_date) > moment(filterData.premium_charged_start) &&
      moment(maturity_date) < moment(filterData.premium_charged_end)
    ) {
      const diff = moment(maturity_date).diff(
        moment(filterData.premium_charged_start),
        "days"
      );
      const cummDateDiff = moment(maturity_date).diff(
        moment(purchase_date),
        "days"
      );
      days_earned = cummDateDiff;
      days_unearned = tenure - cummDateDiff;
      premium_uncharged = (tenure - cummDateDiff) * daily_premium;
      cumulative_premium = cummDateDiff * daily_premium;
      premium_charged = (diff + 1) * daily_premium;
    }
    if (moment(maturity_date) < moment(filterData.premium_charged_start)) {
      days_unearned = 0;
      cumulative_premium = days_earned * daily_premium;
    }
    // bought inside the period, matures after it
    if (
      moment(purchase_date) > moment(filterData.premium_charged_start) &&
      moment(purchase_date) < moment(filterData.premium_charged_end) &&
      moment(maturity_date) > moment(filterData.premium_charged_end)
    ) {
      const diff = moment(filterData.premium_charged_end).diff(
        moment(purchase_date),
        "days"
      );
      const cummDateDiff = moment(filterData.premium_charged_end).diff(
        moment(purchase_date),
        "days"
      );
      days_earned = cummDateDiff;
      days_unearned = tenure - cummDateDiff;
      premium_uncharged = (tenure - cummDateDiff) * daily_premium;
      cumulative_premium = cummDateDiff * daily_premium;
      premium_charged = (diff + 1) * daily_premium;
    }
  }

  // bought and matured inside the period
  if (
    moment(purchase_date) > moment(filterData.premium_charged_start) &&
    moment(maturity_date) < moment(filterData.premium_charged_end)
  ) {
    const cummDateDiff = moment(filterData.premium_charged_end).diff(
      moment(purchase_date),
      "days"
    );
    days_earned = cummDateDiff;
    days_unearned = tenure - cummDateDiff;
    premium_uncharged = (tenure - cummDateDiff) * daily_premium;
    cumulative_premium = cummDateDiff * daily_premium;
    const diff = moment(maturity_date).diff(moment(purchase_date), "days");
    premium_charged = (diff + 1) * daily_premium;
  }

  return {
    id,
    policy_number,
    description,
    institution,
    policy_type,
    purchase_date,
    maturity_date,
    tenure,
    days_earned,
    days_unearned,
    cost,
    cumulative_premium,
    premium_uncharged,
    premium_charged,
    daily_premium,
    status,
  };
}

export const sumBy = (rows, key) =>
  rows.reduce((acc, row) => acc + (Number(row[key]) || 0), 0);
